module.exports = __webpack_public_path__ + "img/spring_trip-20160416-19.faeb22ad.jpg";